{
  "pages.shell.sidebar": "Sayfa gezgini",
  "pages.shell.resize_sidebar": "Gezinme genişliğini ayarla",
  "pages.shell.rename": "Yeniden adlandır",
  "pages.shell.rename_field": "Sayfa adı",
  "pages.shell.copy_link": "Sayfa bağlantısını kopyala",
  "pages.shell.link_copied": "Sayfa bağlantısı kopyalandı",
  "pages.shell.link_copy_failed": "Bağlantı kopyalanamadı.",
  "pages.shell.cycle_blocked": "Bir sayfa kendi alt sayfasının içine taşınamaz.",
  "pages.shell.move_failed": "Sayfa taşınamadı.",
  "pages.shell.start_title": "Nereden başlamak istersin?",
  "pages.shell.start_body": "Boş bir sayfa aç ya da bir çalışma bağlamıyla başla. Sen uygulayana kadar hiçbir kayıt oluşturulmaz.",
  "pages.shell.blank_page": "Boş sayfa",
  "pages.shell.template_blank": "Serbest çalışma sayfası",
  "pages.shell.template_project": "Proje ve plan çalışma bağlamı",
  "pages.shell.template_life": "Yaşam takibi",
  "pages.shell.template_safe": "Önizleme hiçbir şey oluşturmaz. Kayıtlar yalnız şablonu uyguladığında açılır.",
  "pages.shell.full_width": "Tam genişlik",
  "pages.shell.narrow_width": "Dar sütun",
  "pages.shell.save_status": "Kaydetme durumu",
  "pages.shell.subpages": "Alt sayfalar",
  "pages.shell.untitled": "Adsız"
}
